module.exports = {
	"header": "Spotin recruits Head of Marketing",
	"date": "2021/11/08",
	"imgSrc": "10.jpg",
	"imgAlt": "Spotin recruits Head of Marketing",
	"ingress": "By: Dagens Handel (in Swedish)",
	"externalLink": "https://www.dagenshandel.se/article/view/818447/blir_marknadschef_hos_spotin"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/10/article.json
// module id = 81
// module chunks = 0